import {
  // DOMAINS
  GET_DOMAINS,
  GET_DOMAINS_SUCCESS,
  GET_DOMAINS_FAIL,
  GET_CREDENTIALS,
  GET_CREDENTIALS_SUCCESS,
  GET_CREDENTIALS_FAIL,
  ADD_DOMAIN,
  ADD_DOMAIN_SUCCESS,
  ADD_DOMAIN_FAIL,
  UPDATE_DOMAIN,
  UPDATE_DOMAIN_SUCCESS,
  UPDATE_DOMAIN_FAIL,
  DELETE_DOMAIN,
  DELETE_DOMAIN_SUCCESS,
  DELETE_DOMAIN_FAIL,
  // SUBSCRIPTIONS
  GET_SUBS,
  GET_SUBS_SUCCESS,
  GET_SUBS_FAIL,
  ADD_SUB,
  ADD_SUB_SUCCESS,
  ADD_SUB_FAIL,
  UPDATE_SUB,
  UPDATE_SUB_SUCCESS,
  UPDATE_SUB_FAIL,
  DELETE_SUB,
  DELETE_SUB_SUCCESS,
  DELETE_SUB_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

// GET ALL DOMAINS
export const getDomains = () => ({
  type: GET_DOMAINS,
})
export const getDomainsSuccess = departments => ({
  type: GET_DOMAINS_SUCCESS,
  payload: departments,
})
export const getDomainsFail = error => ({
  type: GET_DOMAINS_FAIL,
  payload: error,
})
// GET CREDENTIALS
export const getCredentials = domain => ({
  type: GET_CREDENTIALS,
  payload: domain,
})
export const getCredentialsSuccess = domain => ({
  type: GET_CREDENTIALS_SUCCESS,
  payload: domain,
})
export const getCredentialsFail = error => ({
  type: GET_CREDENTIALS_FAIL,
  payload: error,
})
// ADD NEW DOMAIN
export const addDomain = domain => ({
  type: ADD_DOMAIN,
  payload: domain,
})
export const addDomainSuccess = domain => ({
  type: ADD_DOMAIN_SUCCESS,
  payload: domain,
})
export const addDomainFail = error => ({
  type: ADD_DOMAIN_FAIL,
  payload: error,
})
// UPDATE DOMAIN
export const updateDomain = domain => ({
  type: UPDATE_DOMAIN,
  payload: domain,
})
export const updateDomainSuccess = domain => ({
  type: UPDATE_DOMAIN_SUCCESS,
  payload: domain,
})
export const updateDomainFail = error => ({
  type: UPDATE_DOMAIN_FAIL,
  payload: error,
})
// DELETE DOMAIN
export const deleteDomain = domain => ({
  type: DELETE_DOMAIN,
  payload: domain,
})
export const deleteDomainSuccess = domain => ({
  type: DELETE_DOMAIN_SUCCESS,
  payload: domain,
})
export const deleteDomainFail = error => ({
  type: DELETE_DOMAIN_FAIL,
  payload: error,
})

// GET ALL SUBSCRIPTIONS
export const getSubs = () => ({
  type: GET_SUBS,
})
export const getSubsSuccess = departments => ({
  type: GET_SUBS_SUCCESS,
  payload: departments,
})
export const getSubsFail = error => ({
  type: GET_SUBS_FAIL,
  payload: error,
})
// ADD NEW SUBSCRIPTION
export const addSub = domain => ({
  type: ADD_SUB,
  payload: domain,
})
export const addSubSuccess = domain => ({
  type: ADD_SUB_SUCCESS,
  payload: domain,
})
export const addSubFail = error => ({
  type: ADD_SUB_FAIL,
  payload: error,
})
// UPDATE SUBSCRIPTION
export const updateSub = domain => ({
  type: UPDATE_SUB,
  payload: domain,
})
export const updateSubSuccess = domain => ({
  type: UPDATE_SUB_SUCCESS,
  payload: domain,
})
export const updateSubFail = error => ({
  type: UPDATE_SUB_FAIL,
  payload: error,
})
// DELETE SUBSCRIPTION
export const deleteSub = domain => ({
  type: DELETE_SUB,
  payload: domain,
})
export const deleteSubSuccess = domain => ({
  type: DELETE_SUB_SUCCESS,
  payload: domain,
})
export const deleteSubFail = error => ({
  type: DELETE_SUB_FAIL,
  payload: error,
})


// DISPLAY LOADING ICON
export const showLoading = status => ({
  type: SHOW_LOADING,
  payload: status,
})
export const hideLoading = status => ({
  type: HIDE_LOADING,
  payload: status,
})